/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useCallback, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {AttendanceTable} from './AttendanceTable'
import {ManageBookingServices} from './ManageBookingServices'
import {ManageBookingHotels} from './ManageBookingHotels'
import Accordion from 'react-bootstrap/Accordion'
import {useCheckAccess, useCheckDashboardAccesses} from '../../services/Functional'
import {StatusCounts, HotelStatusCounts} from './partial/statusCounts'
import {ServiceStatusCounters} from './partial/ServiceStatusCounters'
import {HotelStatusCounters} from './partial/HotelStatusCounters'

type ServiceSectionKey = 'services-TH' | 'services-AE'
type HotelSectionKey = 'hotels-TH' | 'hotels-AE'

const DashboardPage: FC = () => {
  const CheckDashboardAccesses = useCheckDashboardAccesses()
  const checkAccess = useCheckAccess()

  const canViewServices = checkAccess('dashboard.services')
  const canViewHotels = checkAccess('dashboard.hotels')

  // Services report supplier buckets; hotels report the two headline counters. Separate
  // shapes, so they are held separately rather than forced into one union.
  const [serviceCounts, setServiceCounts] = useState<
    Partial<Record<ServiceSectionKey, StatusCounts>>
  >({})
  const [hotelCounts, setHotelCounts] = useState<
    Partial<Record<HotelSectionKey, HotelStatusCounts>>
  >({})

  // Stable per-section setters, so the child effect does not re-fire on every wrapper render.
  const setServiceCountsFor = useCallback(
    (key: ServiceSectionKey) => (counts: StatusCounts | undefined) =>
      setServiceCounts((prev) => ({...prev, [key]: counts})),
    []
  )
  const setHotelCountsFor = useCallback(
    (key: HotelSectionKey) => (counts: HotelStatusCounts | undefined) =>
      setHotelCounts((prev) => ({...prev, [key]: counts})),
    []
  )
  const onServicesTH = useMemo(() => setServiceCountsFor('services-TH'), [setServiceCountsFor])
  const onServicesAE = useMemo(() => setServiceCountsFor('services-AE'), [setServiceCountsFor])
  const onHotelsTH = useMemo(() => setHotelCountsFor('hotels-TH'), [setHotelCountsFor])
  const onHotelsAE = useMemo(() => setHotelCountsFor('hotels-AE'), [setHotelCountsFor])

  return (
    <>
      <div className='row gy-5 gx-xl-8'>
        <div className='col-xl-6'>
          <AttendanceTable className='card-xxl-stretch mb-5 mb-xl-8' />
        </div>
      </div>
      <Accordion>
        {canViewServices && CheckDashboardAccesses('TH') && (
          <Accordion.Item eventKey='0'>
            <Accordion.Header className='text-white'>
              <h5 className='mb-0'>Thailand - Manage Booking Services</h5>
              <ServiceStatusCounters counts={serviceCounts['services-TH']} />
            </Accordion.Header>
            <Accordion.Body>
              <ManageBookingServices
                country='Thailand'
                countryCode='TH'
                onStatusCounts={onServicesTH}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}
        {canViewServices && CheckDashboardAccesses('AE') && (
          <Accordion.Item eventKey='1'>
            <Accordion.Header className='text-white'>
              <h5 className='mb-0'>United Arab Emirates - Manage Booking Services</h5>
              <ServiceStatusCounters counts={serviceCounts['services-AE']} />
            </Accordion.Header>
            <Accordion.Body>
              <ManageBookingServices
                country='United Arab Emirates'
                countryCode='AE'
                onStatusCounts={onServicesAE}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}
        {canViewHotels && CheckDashboardAccesses('TH') && (
          <Accordion.Item eventKey='2'>
            <Accordion.Header className='text-white'>
              <h5 className='mb-0'>Thailand - Manage Hotels (Regular & Custom)</h5>
              <HotelStatusCounters counts={hotelCounts['hotels-TH']} />
            </Accordion.Header>
            <Accordion.Body>
              <ManageBookingHotels
                country='Thailand'
                countryCode='TH'
                onStatusCounts={onHotelsTH}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}
        {canViewHotels && CheckDashboardAccesses('AE') && (
          <Accordion.Item eventKey='3'>
            <Accordion.Header className='text-white'>
              <h5 className='mb-0'>United Arab Emirates - Manage Hotels (Regular & Custom)</h5>
              <HotelStatusCounters counts={hotelCounts['hotels-AE']} />
            </Accordion.Header>
            <Accordion.Body>
              <ManageBookingHotels
                country='United Arab Emirates'
                countryCode='AE'
                onStatusCounts={onHotelsAE}
              />
            </Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>
      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        {/* begin::Col */}
        <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
          {/*<CardsWidget20
          className='h-md-50 mb-5 mb-xl-10'
          description='Active Projects'
          color='#F1416C'
          img={toAbsoluteUrl('/media/patterns/vector-1.png')}
        />
        <CardsWidget7
          className='h-md-50 mb-5 mb-xl-10'
          description='Professionals'
          icon={false}
          stats={357}
          labelColor='dark'
          textColor='gray-300'
        />*/}
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        {/*<div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <CardsWidget17 className='h-md-50 mb-5 mb-xl-10' />
        <ListsWidget26 className='h-lg-50' />
      </div>*/}
        {/* end::Col */}

        {/* begin::Col */}
        {/*<div className='col-xxl-6'>
        <EngageWidget10 className='h-md-100' />
      </div>*/}
        {/* end::Col */}
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row gx-5 gx-xl-10'>
        {/* begin::Col */}
        <div className='col-xxl-6 mb-5 mb-xl-10'>
          {/* <app-new-charts-widget8 cssclassName="h-xl-100" chartHeight="275px" [chartHeightNumber]="275"></app-new-charts-widget8> */}
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-xxl-6 mb-5 mb-xl-10'>
          {/* <app-cards-widget18 cssclassName="h-xl-100" image="./assets/media/stock/600x600/img-65.jpg"></app-cards-widget18> */}
        </div>
        {/* end::Col */}
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row gy-5 gx-xl-8'>
        <div className='col-xxl-4'>{/*<ListsWidget3 className='card-xxl-stretch mb-xl-3' />*/}</div>
        <div className='col-xl-8'>
          {/*<TablesWidget10 className='card-xxl-stretch mb-5 mb-xl-8' />*/}
        </div>
      </div>
      {/* end::Row */}

      {/* begin::Row */}
      <div className='row gy-5 g-xl-8'>
        <div className='col-xl-4'>{/*<ListsWidget2 className='card-xl-stretch mb-xl-8' />*/}</div>
        <div className='col-xl-4'>{/*<ListsWidget6 className='card-xl-stretch mb-xl-8' />*/}</div>
        <div className='col-xl-4'>
          {/*<ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' items={5} />*/}
          {/* partials/widgets/lists/_widget-4', 'class' => 'card-xl-stretch mb-5 mb-xl-8', 'items' => '5' */}
        </div>
      </div>
      {/* end::Row */}

      {/*<div className='row g-5 gx-xxl-8'>
      <div className='col-xxl-4'>
        <MixedWidget8
          className='card-xxl-stretch mb-xl-3'
          chartColor='success'
          chartHeight='150px'
        />
      </div>
      <div className='col-xxl-8'>
        <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' />
      </div>
    </div>*/}
    </>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
